// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tabs-header.-fixed[data-v-53492210]{position:fixed;top:0;z-index:50;border:none;box-shadow:0 3px 10px 0 hsla(0,0%,60%,.75);box-sizing:border-box}.tabs-header .item[data-v-53492210]{transition:background-color .2s linear,color .3s linear}.tabs-header.-fixed ._onlyFixed[data-v-53492210]{display:inline-block!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
